import React, { useContext } from 'react';
import { LocaleContext } from 'shared';

import { AdminToolBoxWrapper, AdminToolDescription, AdminToolName } from './AdminToolBox.styles';
import { AdminToolBoxProps } from './AdminToolBox.types';

export const AdminToolBox = (adminTool: AdminToolBoxProps) => {
  const localeContext = useContext(LocaleContext);

  return (
    <AdminToolBoxWrapper className="adminTool">
      <AdminToolName className="adminTool__header">
        {localeContext.formatMessage({ id: adminTool.nameId })}
      </AdminToolName>
      <AdminToolDescription className="adminTool__description">
        {localeContext.formatMessage({ id: adminTool.descriptionId })}
      </AdminToolDescription>
    </AdminToolBoxWrapper>
  );
};
